<template>
  <div>
    <!--<fundings-list />-->
    <fundings-list-pagination/>
  </div>
</template>

<script>
  // import FundingsList from '@/components/fundings/FundingsList.vue'
  import FundingsListPagination from '@/components/fundings/FundingsListPagination.vue'

  export default {
    components: {
      // FundingsList
      FundingsListPagination
    }
  }
</script>
